/* export const columns = [{
    name: 'Name',
    key: 'status',
}, {
    name: '# of Properties',
    key: 'properties',
    class: 'Pipeline_column_numeric',
}, {
    name: 'Agents',
    key: 'loanAmount',
    class: 'Pipeline_column_numeric',
    format: '$',
},
{
    name: 'Investors',
    key: 'loanAmount',
    class: 'Pipeline_column_numeric',
    format: '$',
}
]; */

export const columns = [{
    name: 'Name',
    key: 'agent_name',
},
{
    name: 'Courting',
    key: 'hsc_courting_count',
    class: 'Pipeline_column_numeric',
},
{
    name: 'Hot List',
    subColumns: [{
        name: 'Properties',
        key: 'hsc_properties_count',
        class: 'Pipeline_column_numeric',
    },{
        name: 'Agents',
        key: 'hsc_agents_count',
        class: 'Pipeline_column_numeric',
    }, {
        name: 'Investors',
        key: 'hsc_investors_count',
        class: 'Pipeline_column_numeric',
    }, {
        name: 'Lenders',
        key: 'hsc_lender_count',
        class: 'Pipeline_column_numeric',
    }]
}, 
{
    name: 'Follow Up',
    key: 'hsc_followup_count',
    class: 'Pipeline_column_numeric',
}
];